import React from "react";
import Hero from "../Components/Hero/Hero";
import Pricing from "../Components/Pricing/Pricing";
const PricingPage = () => {
  return (
    <div className="home_page">
      <Hero />
      <Pricing />
    </div>
  );
};

export default PricingPage;
